var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useService from "../../Hooks/useService";
import MessageService from "../../../Services/Message.service";
import { AlertSuccess } from "../../UI/StandardAlerts/StandardAlerts";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import Loading from "../../UI/Loading/Loading";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ValidationService from "../../../Services/Shared/Validation.service";
import useUniqueId from "../../Hooks/useUniqueId";
const SaveAsTemplateModal = (_a) => {
    var { subject, body } = _a, modalProps = __rest(_a, ["subject", "body"]);
    const makeId = useUniqueId()[1];
    const [messageTemplateState, saveTemplate, messageTemplateActions] = useService(MessageService.saveMessageTemplate);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { onModalClosed: () => {
            messageTemplateActions.clear();
            modalProps.onModalClosed();
        }, modalTitle: "Save Message As Template", saveButtonContents: (isLoading) => (_jsxs(_Fragment, { children: [isLoading && _jsx(Loading, { addMarginRight: true }), _jsx(FAIcon, { icon: "save", type: "fas" }), " Save"] })), handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
            const messageTemplate = {
                name: formState.name,
                subject,
                body,
            };
            yield saveTemplate({ messageTemplate });
        }), keepModalOpenAfterSuccess: true, children: (formProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: makeId("name"), children: "Name" }), _jsx("input", { id: makeId("name"), type: "text", name: "name", placeholder: "Enter a name for your template", className: ValidationService.makeClassName(formProps.errors, "name", "form-control"), ref: formProps.register({ required: "Name is required" }) }), _jsx("div", { className: "invalid-feedback", children: "Name is required" })] }), messageTemplateState.wasSuccessful && (_jsx(AlertSuccess, { message: "Message Template successfully saved." }))] })) })));
};
export default SaveAsTemplateModal;
